import { Component } from '@angular/core';
import { AuthenticationService } from './_services/authentication.service';
import { Router } from '@angular/router';
import { CookieService } from "angular2-cookie/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  currentUser;

  constructor(private authenticationservice: AuthenticationService, private router: Router, private _cookieService: CookieService) 
  {
    let access_token_otacon = this._cookieService.get('access_token_otacon');
    // console.log(access_token_otacon);
    if (access_token_otacon) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    } else {
      localStorage.clear();
      this.currentUser = undefined;
    }
    
  }

  public callback() {
    // /assets/erd/index.html
    console.log('Time out');
    this.authenticationservice.logout();
    location.reload();
    localStorage.removeItem('currentUser');
    localStorage.clear();
    this.router.navigate(['/login']);
    this.currentUser = undefined;

  }
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/app.component.ts